import React, { useState, useEffect } from "react"
import { Col, Card } from "antd"

const CourierCard = ({ key, name, url, logo }) => {
  return (
    <Col key={key} span={12} lg={4}>
      {url == "#" ? (
        <Card style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 8,
          border: "none",
          boxShadow: "0px 8px 40px rgba(45, 85, 120, 0.12)",
          aspectRatio: "1/1",
        }} className="courier-card">
          <img src={`../images/couriers/${logo}`} style={{
            maxWidth: "120px"
          }} />
        </Card>
      ) : (
        <>
          <a href={url} className="courier-link">
            <Card style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 8,
              border: "none",
              boxShadow: "0px 8px 40px rgba(45, 85, 120, 0.12)",
              aspectRatio: "1/1",
            }} className="courier-card">
              <img src={`../images/couriers/${logo}`} style={{
                maxWidth: "120px"
              }} />
              <button>Apie kurjerį</button>
            </Card>
          </a >
        </>

      )}

    </Col >
  )
}

export default CourierCard
